import { getParkList, getParkRouteList, getParkScenicList } from "@/api/map";
const pointTypeList = [
  { key: "naturalList", image: "./image/ziran.png" },
  { key: "humanList", image: "./image/ziran.png" },
  { key: "facilityList", image: "./image/ziran.png" },
  { key: "communityList", image: "./image/ziran.png" },
];

const defaultFacilityTypeList = [{ value: 1 }, { value: 2 }, { value: 3 }];

const state = {
  parkMap: {},
  parkResourceMap: {},
  flying: false,
  is2d: false,
  activeScenicName: "",
  activeScenicId: "",
  noticeCardX: "",
  noticeCardY: "",
};

const mutations = {
  SET_PARKMAP: (state, parkList = []) => {
    state.parkMap = Object.freeze(parkList.reduce((r, c) => ({ ...r, [c.id]: c }), {}));
  },
  SET_PARK_CONTENT: (state, { parkId, routeList, scenicMap }) => {
    const scenicList = pointTypeList.reduce((r, c) => {
      const { key, image } = c;
      const list = scenicMap[key] || [];
      return r.concat(list.map((item) => ({ ...item, icon: image, type: key })));
    }, []);

    const defaultScenicTypeMap = {
      naturalList: true,
      humanList: true,
      facilityList: new Set(["facilityList", ...defaultFacilityTypeList.map(({ value }) => value)]),
      communityList: true,
    };

    state.parkResourceMap = Object.assign({}, state.parkResourceMap, {
      [parkId]: {
        routeList: Object.freeze(routeList),
        scenicList,
        defaultScenicTypeMap,
        scenicTypeMap: {},
        // scenicTypeMap: Object.entries(defaultScenicTypeMap).reduce((r, c) => {
        //   const [key, value] = c;
        //   return { ...r, [key]: typeof value === 'boolean' ? value : new Set([...value]) };
        // }, {}),
      },
    });
  },
  SCENIC_SELECT: (state, { parkId, scenicType, scenicSubType, clear = false }) => {
    const { scenicTypeMap, defaultScenicTypeMap } = state.parkResourceMap[parkId];

    // 清除选中
    if (clear) {
      state.parkResourceMap[parkId].scenicTypeMap = Object.entries(defaultScenicTypeMap).reduce((r, c) => {
        const [key, value] = c;
        return { ...r, [key]: typeof value === "boolean" ? false : new Set() };
      }, {});
      return;
    }

    console.log("isClear", clear, scenicType, scenicSubType);
    // 全选
    if (!scenicType) {
      state.parkResourceMap[parkId].scenicTypeMap = Object.entries(defaultScenicTypeMap).reduce((r, c) => {
        const [key, value] = c;
        return {
          ...r,
          [key]: typeof value === "boolean" ? value : new Set([...value]),
        };
      }, {});
      return;
    }
    const scenicTypeSelect = scenicTypeMap[scenicType];
    const options = defaultFacilityTypeList;
    // 无子类型的选择
    if (typeof scenicTypeSelect === "boolean") {
      scenicTypeMap[scenicType] = !scenicTypeSelect;
    } else if (scenicSubType) {
      if (scenicTypeSelect.has(scenicSubType)) {
        scenicTypeSelect.delete(scenicSubType);
        scenicTypeSelect.delete(scenicType);
      } else {
        scenicTypeSelect.add(scenicSubType);
        scenicTypeSelect.size >= options.length && scenicTypeSelect.add(scenicType);
      }
    } else if (scenicTypeSelect.size >= options.length) {
      scenicTypeSelect.clear();
    } else {
      [scenicType, ...options.map(({ value }) => value)].forEach(scenicTypeSelect.add.bind(scenicTypeSelect));
    }

    state.parkResourceMap[parkId].scenicTypeMap = Object.assign({}, scenicTypeMap);
  },
  SET_FLY_STATUS: (state, status) => {
    state.flying = status;
  },
  SET_MAP_TYPE: (state) => {
    state.is2d = !state.is2d;
  },
  CLEAR_STATUS: (state) => {
    state.flying = false;
    state.is2d = false;
    state.activeScenicName = "";
    state.activeScenicId = "";
  },
  CLEAR_ACTIVE_SCENIC:
    (state,
    () => {
      state.activeScenicName = "";
      state.activeScenicId = "";
      state.noticeCardX = "";
      state.noticeCardY = "";
    }),
  CLEAR_ACTIVE_SCENIC_NOTICE:
    (state,
    () => {
      state.activeScenicId = "";
    }),
  SET_ACTIVE_SCENIC: (state, { scenicName, parkId }) => {
    // if (state.is2d) {
    //   const { scenicList } = state.parkResourceMap[parkId] || {};
    //   const scenic = (scenicList || []).find(
    //     (item) => item.title === scenicName
    //   );
    //   state.activeScenicName = scenicName;
    //   return;
    // }

    const { scenicList } = state.parkResourceMap[parkId] || {};
    const scenic = (scenicList || []).find((item) => item.title === scenicName);
    // console.log(scenic);
    state.activeScenicName = scenicName;
    state.activeScenicId = `point-${scenic.type}-${scenic.category}_${scenic.id}`;
    if (state.is2d) {
      console.log("177-2d");
      return;
    }

    const posi = window.viewer.entities.getById(state.activeScenicId);
    var position = posi.position.getValue(window.viewer.clock.currentTime);
    var canvasCoordinates = window.viewer.scene.cartesianToCanvasCoordinates(position);

    if (window.Cesium.defined(canvasCoordinates)) {
      state.noticeCardX = canvasCoordinates.x;
      state.noticeCardY = canvasCoordinates.y;
    }
  },
};

const actions = {
  async updateParkList({ commit, state }) {
    const res = await getParkList();
    commit("SET_PARKMAP", res.data);
    return state.parkMap;
  },
  async updateParkResource({ commit, state }, parkId) {
    if (!state.parkResourceMap[parkId]) {
      const [parkRouteRes, parkScenicRes] = await Promise.all([getParkRouteList(parkId), getParkScenicList(parkId)]);
      commit({
        type: "SET_PARK_CONTENT",
        parkId,
        routeList: parkRouteRes.data || [],
        scenicMap: parkScenicRes.data || [],
      });
    }
    return state.parkResourceMap[parkId];
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
